import styled from '@themes/theme'
import { ButtonStyles } from '@styles/button.style'
import { favoritePulseAni, favoriteTxtAni } from '@styles/match.style'

export const FavoriteBtn = styled.button`
  ${ButtonStyles};
  z-index: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 55px;
  margin-right: 4px;
  overflow: visible;
  background: ${props => props.theme.color.TP};
  .favorite-btn-img{
    width: 18px;
    height: auto;
    opacity: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .favorite-btn-active-img{
    width: 18px;
    height: 18px;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .favorite-pulse {
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    &.pulse-2 {
      width: 6px;
      height: 6px;
    }
  }
  &.active {
    .favorite-btn-img{
      opacity: 0;
    }
    .favorite-btn-active-img{
      opacity: 1;
    }
    &.ani {
      .favorite-btn-active-img{
        animation: ${favoriteTxtAni} .4s 1 forwards cubic-bezier(.43, -0.78, 0, 1.66);
      }
      .favorite-pulse {
        opacity: 1;
        animation: ${favoritePulseAni} .65s 1 ease-out;

        &.pulse-2 {
          animation-delay: .1s;
        }
      }
    }
  }
`